<template>
  <!--
    매장 계정 사이드 메뉴 「주문 임시중단」(`/v/business/store/pause`, appserver SQL 033 §3) — 세션 매장 하나를
    읽어 임시중단 카드 하나를 그린다. 카드는 매장 상세(사업장 트리·매장 관리)와 **같은 컴포넌트**다.
  -->
  <div class="contain">
    <div class="store-pause-view">
      <el-alert v-if="loadError" type="error" :title="loadError" :closable="false" show-icon />

      <StorePauseCard v-else-if="store" :store-cd="store.storeCd" :paused-until.sync="store.pausedUntil" />
    </div>
  </div>
</template>

<script>
import StorePauseCard from '@/components/store/StorePauseCard.vue'
import { httpErrorMessage } from '@/plugins/http/policy'
import { STORE_PAUSE_TEXT } from '@/utils/storePause'

export default {
  name: 'StorePauseView',

  components: { StorePauseCard },

  data() {
    return {
      /** 이 화면이 쓰는 매장 사실 둘 — 매장 코드와 임시중단 만료 시각(카드와 `.sync` 로 나눈다) */
      store: null,
      loadError: '',
    }
  },

  created() {
    this.load()
  },

  methods: {
    /**
     * 세션 매장(`GET /store/info`) — 응답의 `pausedUntil` 이 지금 상태다. 실패하면 서버 문장을 그대로 말하고
     * 카드를 그리지 않는다(대상 매장이 없으면 걸 곳도 없다).
     */
    async load() {
      try {
        const response = await this.$axios.get('/store/info', { showErrorMessage: false })
        const detail = (response && response.data) || {}

        if (detail.storeCd == null) {
          this.loadError = this.$t(STORE_PAUSE_TEXT.loadFailed)
          return
        }

        this.store = { storeCd: detail.storeCd, pausedUntil: detail.pausedUntil || null }
      } catch (error) {
        this.loadError = httpErrorMessage(error, this.$t(STORE_PAUSE_TEXT.loadFailed))
      }
    },
  },
}
</script>

<style scoped>
.store-pause-view {
  max-width: 720px;
}
</style>
